// extracted by mini-css-extract-plugin
export var image = "_j0-1";
export var imageContainer = "_j0-0";